
function initializeVariantEvents(container) {
  const variantDataScript = container.querySelector('[data-selected-variant]');
  if (!variantDataScript) return;

  const variants = JSON.parse(variantDataScript.textContent);
  const form = container.querySelector('form');
  const hiddenInput = form.querySelector('.hidden-variant-id');
  const optionInputs = form.querySelectorAll('input[type="radio"]');
  const quantityInput = form.querySelector('input[name="quantity"]');

  const updateVariant = () => {
    const selectedOptions = [];
    const optionPositions = [...new Set(Array.from(optionInputs).map(i => i.dataset.optionPosition))];

    for (let pos of optionPositions) {
      const checkedInput = form.querySelector(`input[data-option-position="${pos}"]:checked`);
      if (!checkedInput) return;

      selectedOptions.push(checkedInput.value);

      const selectedSpan = container.querySelector(`span[data-selected-value][data-option-name="${checkedInput.dataset.optionName}"]`);
      if (selectedSpan) selectedSpan.textContent = checkedInput.value;
    }

    const selectedSize = selectedOptions[0];
    const availableColors = variants
      .filter(v => v.options[0] === selectedSize && v.available)
      .map(v => v.options[1]);

    form.querySelectorAll(`input[data-option-position="2"]`).forEach(input => {
      const td = input.closest('td');

      if (availableColors.includes(input.value)) {
        input.disabled = false;
        input.closest('label')?.classList.remove('disabled');
        td?.classList.remove('disabled');
      } else {
        input.disabled = true;
        input.closest('label')?.classList.add('disabled');
        td?.classList.add('disabled');
      }

      td?.classList.toggle('active', input.checked);
    });

    
    const matchedVariant = variants.find(v =>
      v.options.length === selectedOptions.length &&
      v.options.every((opt, idx) => opt === selectedOptions[idx])
    );

   

 
    if (matchedVariant) {
      hiddenInput.value = matchedVariant.id;
      const rule = matchedVariant.quantity_rule || {};
      
      if (quantityInput) {
        const minQty = parseInt(rule.min) || 1;
        const stepQty = parseInt(rule.increment) || 1;
        const maxQty = rule.max ? parseInt(rule.max) : null;

        quantityInput.min = minQty;
        quantityInput.step = stepQty;
        quantityInput.value = minQty;

        quantityInput.setAttribute('data-min', minQty);
        quantityInput.setAttribute('data-step', stepQty);
        if (maxQty) {
          quantityInput.max = maxQty;
          quantityInput.setAttribute('data-max', maxQty);
        } else {
          quantityInput.removeAttribute('max');
          quantityInput.removeAttribute('data-max');
        }
      }
    }
  };

  
  if (quantityInput) {
    quantityInput.addEventListener('input', () => {
      const min = parseInt(quantityInput.min);
      const step = parseInt(quantityInput.step);
      let val = parseInt(quantityInput.value);

      if ((val - min) % step !== 0) {
        const remainder = (val - min) % step;
        val = val - remainder;
        quantityInput.value = val;
      }
    });
  }

  
  if (!form.submitHandlerAttached) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(res => res.json())
        .then(data => {
          $("#CartDrawer").load(location.href + " #CartDrawer>*", function () {
            $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble>*");
            $("cart-drawer").removeClass("is-empty");
            setTimeout(() => {
              $("cart-drawer").addClass("active");
              $("body").addClass("overflow-hidden");
              $("html").addClass("cartdrawer_hidden");
            }, 500);
          });

          if (!$("#CartDrawer-Overlay").data("event-added")) {
            $("#CartDrawer-Overlay").on("click", function (evt) {
              const container = $("cart-drawer");
              if (!$(evt.target).closest("cart-drawer").length) {
                container.removeClass("active");
                $("body").removeClass("overflow-hidden");
                $("html").removeClass("cartdrawer_hidden");
              }
            });
            $("#CartDrawer-Overlay").data("event-added", true);
          }
        })
        .catch(err => console.error('Add to cart failed:', err));
    });

    form.submitHandlerAttached = true;
  }

  // ✅ Handle swatch clicks
  optionInputs.forEach(input => {
    input.addEventListener('change', () => {
      updateVariant();

      optionInputs.forEach(radio => {
        const td = radio.closest('td');
        if (td) {
          td.classList.toggle('active', radio.checked);
        }
      });
    });
  });

  updateVariant(); // Initial load
}

// ✅ Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.variant-toggle-container').forEach(container => {
    initializeVariantEvents(container);
  });
});







$(document).ready(function () {
  function toggleVariantBox(event) {
    event.preventDefault(); // important for iOS
    event.stopPropagation();

    const productId = $(this).data("product-id");
    const box = $(`#variant-box-${productId}`);

    $(".variant-toggle-container").each(function () {
      if (this !== box[0]) {
        $(this).addClass("hidden");
      }
    });

    box.toggleClass("hidden");

    if (typeof initializeVariantEvents === "function") {
      initializeVariantEvents(box[0]);
    }
  }

  // Bind both click and touchend for iOS compatibility
  $(document).on("click touchend", ".custom-variant-cart", toggleVariantBox);
});


$('.header__icons .header__icon.header__icon--cart').click(function(){
    $("html").addClass("cartdrawer_hidden");
});

$('.drawer__inner .drawer__close').click(function(){
    $("html").removeClass("cartdrawer_hidden");
});


$(document).on("click", function () {
   $("#CartDrawer-Overlay").on("click", function (evt) {
      const container = $("cart-drawer");
      if (!$(evt.target).closest("cart-drawer").length) {
        container.removeClass("active");
        $("body").removeClass("overflow-hidden");
        $("html").removeClass("cartdrawer_hidden");
      } else {
        $("body").removeClass("overflow-hidden");
        $("html").removeClass("cartdrawer_hidden");
        container.removeClass("active");
      }
    });
});
$(document).on("click", function () {
  $(".variant-toggle-container").addClass("hidden");
});
$(document).on("click", function () {
  $(".variant-toggle-container").addClass("hidden");
});

$(document).on("click", ".variant-toggle-container", function (e) {
  e.stopPropagation();
});

$(document).on('click', '.drawer__close', function () {
  $('html').removeClass('cartdrawer_hidden');
});



